export default [
  {
    path: '',
    name: 'pre-sofono',
    component: () => import(/* webpackChunkName: "pre-sofono" */ '@/apps/preSofono/pages/PreSofonoPage.vue')
  }
]
